export const API_URL = process.env.API_URL || "http://localhost:8282/";
//export const API_URL = "https://api.domagolf.com/";
//export const API_URL = "https://preprod-api.domagolf.com/";
export default {};
